import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./ChatList.module.css";
import { CustomButton, CustomTooltip, InfiniteList2 } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import ChatRow from "./ChatRow";
import { AiChatService } from "../../../../api";
import { useApi } from "../../../../common/hooks";

const ChatList = ({ loading = false, onChangeSelectedChat, onResponse, onSetToRefresh, selectedChat, toRefresh }) => {
	const { call: getAllChats } = useApi(AiChatService.getAllChats);
	const projectId = useSelector(({ context }) => context.project?.id);
	const [request, setRequest] = useState(null);
	useEffect(() => {
		if (projectId && toRefresh) {
			setRequest(
				() =>
					({ page, limit }) =>
						getAllChats({ projectId }, { page, limit })
			);
		}
	}, [getAllChats, projectId, toRefresh]);
	const handleStartNewConversation = () => {
		onChangeSelectedChat(0);
	};
	const rowRenderer = (chat) => (
		<ChatRow
			key={chat.id}
			data-testid={`chat-row-${chat.id}`}
			loading={loading}
			row={chat}
			selected={chat.id === selectedChat}
			onChangeSelectedChat={onChangeSelectedChat}
			onSetToRefresh={onSetToRefresh}
		/>
	);
	return (
		<CustomTooltip title={loading ? translate("ai-chat.chat-list.loading") : ""}>
			<div className={styles.container}>
				<div className={styles.btn__container}>
					<CustomButton
						color="secondary"
						disabled={loading}
						size="sm"
						variant="outlined"
						onClick={handleStartNewConversation}
					>
						{translate("ai-chat.chat-list.new")}
					</CustomButton>
				</div>
				<div className={styles.conversationList}>
					<InfiniteList2
						callOnResponse={onResponse}
						className={styles.infiniteList}
						request={request}
						rowRenderer={rowRenderer}
						scrollContainerClassName={styles.infiniteList__scrollContainer}
					/>
				</div>
			</div>
		</CustomTooltip>
	);
};

export default ChatList;
